import EmblaCarousel from 'embla-carousel';

const emblaMobileSlider = () => {
  const emblaNodes = document.querySelectorAll(".embla-mobile-slider");

  if (!emblaNodes.length) return;

  const emblaApis = new Map();

  const initOrDestroySlider = (node) => {
    const existingApi = emblaApis.get(node);

    if (existingApi) {
      existingApi.destroy();
      emblaApis.delete(node);
    }

    if (window.innerWidth < 767) {
      const dragFree = node.dataset.dragFree === 'true';
      
      const mobileOptions = { 
        loop: false,
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: dragFree,
        dragThreshold: 5,
        skipSnaps: false,
        slidesToScroll: 1,
        startIndex: 0
      };
      
      const newApi = EmblaCarousel(node.querySelector('.embla__viewport'), mobileOptions);
      emblaApis.set(node, newApi);
    }
  };

  emblaNodes.forEach((node) => {
    initOrDestroySlider(node);
  });

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      emblaNodes.forEach((node) => {
        initOrDestroySlider(node);
      });
    }, 150);
  });
};

export { emblaMobileSlider };